export const es = {
  "app.title": "survivrr.io",
  "menu.online": "En línea",
  "menu.offline": "Sin conexión",
  "menu.play": "Jugar",
  "menu.name": "Nombre",
  "menu.ballColor": "Color de la bola",
  "menu.nameColor": "Color del nombre",
  "menu.moreInfo": "Más información",
  "menu.moreInfoTitle": "Más información",
  "menu.moreInfoSubtitle": "Páginas legales, detalles de cookies e información de contacto.",
  "menu.back": "Volver",
  "menu.privacySettings": "Configuración de privacidad",
  "menu.cookiePolicy": "Política de cookies",
  "menu.privacyPolicy": "Política de privacidad",
  "menu.termsOfService": "Términos del servicio",
  "menu.emailButton": "Envíame un correo",
  "menu.websiteButton": "Visita mi sitio web",
  "menu.contactEmailLabel": "E-mail de contacto:",
  "menu.emailLabel": "E-mail:",
  "menu.websiteLabel": "Visita mi sitio web:",
  "menu.nameRequired": "Primero escribe un nombre.",
  "moreInfo.privacySettings.intro1": "Puedes gestionar tus opciones de privacidad en este sitio mediante el mensaje de consentimiento mostrado por nuestro proveedor de publicidad cuando esté disponible.",
  "moreInfo.privacySettings.intro2": "También puedes controlar las cookies y el almacenamiento local desde la configuración de tu navegador en cualquier momento.",
  "moreInfo.privacySettings.adsHeading": "Controles de publicidad",
  "moreInfo.privacySettings.adsParagraph": "Algunos anuncios pueden ser proporcionados por Google u otros socios. Las opciones de publicidad personalizada también se pueden gestionar directamente en la configuración de anuncios de Google.",
  "moreInfo.privacySettings.adsBullet1": "Abre los controles de anuncios de Google en myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "Borra las cookies o los datos del sitio si quieres restablecer tus opciones de consentimiento.",
  "moreInfo.privacySettings.adsBullet3": "Usa la configuración de privacidad de tu navegador para bloquear o limitar las cookies.",
  "moreInfo.privacySettings.localHeading": "Configuración local",
  "moreInfo.privacySettings.localParagraph": "Este juego guarda preferencias locales básicas como tu nombre de jugador, colores, preferencia de sonido e idioma para que el sitio pueda recordarlas en tu dispositivo.",
  "moreInfo.cookiePolicy.intro1": "Este sitio utiliza cookies y tecnologías similares de almacenamiento para ejecutar el juego, recordar tu configuración y apoyar la publicidad.",
  "moreInfo.cookiePolicy.intro2": "Las cookies también pueden utilizarse para medición, prevención de fraude y personalización de anuncios según tus opciones de consentimiento y los servicios activados en el sitio.",
  "moreInfo.cookiePolicy.typesHeading": "Tipos de cookies y almacenamiento que podemos usar",
  "moreInfo.cookiePolicy.typeBullet1": "Almacenamiento esencial utilizado para que el sitio funcione.",
  "moreInfo.cookiePolicy.typeBullet2": "Almacenamiento de preferencias utilizado para recordar tu nombre, colores, idioma y configuración de sonido.",
  "moreInfo.cookiePolicy.typeBullet3": "Cookies de publicidad o medición utilizadas por socios publicitarios como Google cuando los anuncios están activados.",
  "moreInfo.cookiePolicy.manageHeading": "Cómo gestionar las cookies",
  "moreInfo.cookiePolicy.manageParagraph": "Puedes gestionar las cookies mediante el mensaje de consentimiento del sitio cuando esté disponible, o desde la configuración de tu navegador. Desactivar algunas cookies puede afectar funciones del sitio o la entrega de anuncios.",
  "moreInfo.privacyPolicy.intro1": "Este sitio es un juego de navegador operado por Michał Kierzkowski. Intentamos recopilar la menor cantidad posible de información personal.",
  "moreInfo.privacyPolicy.intro2": "No se requiere una cuenta para jugar. El juego puede guardar preferencias locales básicas en tu dispositivo y procesar datos de juego necesarios para partidas en línea.",
  "moreInfo.privacyPolicy.infoHeading": "Información que podemos procesar",
  "moreInfo.privacyPolicy.infoBullet1": "Tu nombre de jugador elegido y la configuración cosmética.",
  "moreInfo.privacyPolicy.infoBullet2": "Datos básicos de sesión necesarios para ejecutar funciones multijugador.",
  "moreInfo.privacyPolicy.infoBullet3": "Datos de dispositivo, navegador o publicidad recopilados por socios de análisis o publicidad si dichos servicios están activados.",
  "moreInfo.privacyPolicy.useHeading": "Cómo usamos la información",
  "moreInfo.privacyPolicy.useBullet1": "Para ejecutar el juego y las salas en línea.",
  "moreInfo.privacyPolicy.useBullet2": "Para recordar tu configuración en tu dispositivo.",
  "moreInfo.privacyPolicy.useBullet3": "Para mejorar el rendimiento, la seguridad y la estabilidad.",
  "moreInfo.privacyPolicy.useBullet4": "Para mostrar anuncios cuando la publicidad esté activada.",
  "moreInfo.privacyPolicy.contactHeading": "Contacto",
  "moreInfo.privacyPolicy.contactParagraph1": "Si tienes preguntas relacionadas con la privacidad, contacta con: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Sitio web: michalkierzkowski.com",
  "moreInfo.terms.intro1": "Al usar este sitio, aceptas utilizar el juego de forma legal y justa.",
  "moreInfo.terms.intro2": "El juego se proporciona tal como está y puede cambiar, interrumpirse o eliminarse en cualquier momento.",
  "moreInfo.terms.rulesHeading": "Reglas",
  "moreInfo.terms.ruleBullet1": "No abuses de errores, trampas, automatización o exploits.",
  "moreInfo.terms.ruleBullet2": "No intentes dañar el servicio ni a otros jugadores.",
  "moreInfo.terms.ruleBullet3": "No utilices nombres o contenido ofensivo, ilegal o engañoso.",
  "moreInfo.terms.limitationHeading": "Limitación",
  "moreInfo.terms.limitationParagraph": "No somos responsables de pérdidas, interrupciones o daños derivados del uso del sitio en la medida máxima permitida por la ley.",
  "moreInfo.terms.changesHeading": "Cambios",
  "moreInfo.terms.changesParagraph": "Estos términos pueden actualizarse en el futuro. El uso continuado del sitio después de las actualizaciones significa que aceptas los términos actualizados.",
  "status.offline": "Iniciando partida sin conexión...",
  "status.connecting": "Conectando al servidor...",
  "queue.title": "Esperando una sala",
  "queue.menu": "Volver al menú principal",
  "game.pressToMove": "Pulsa en cualquier lugar para moverte",
  "game.touchToMove": "Toca en cualquier lugar para moverte",
  "game.leaderboard": "Clasificación",
  "game.hp": "Vida",
  "game.level": "Nivel",
  "game.xp": "XP",
  "game.respawning": "Reapareciendo...",
  "gameEnd.title": "Fin de la partida",
  "gameEnd.winTitle": "Has ganado",
  "gameEnd.subtitle": "La partida ha terminado. Reaparece para empezar la siguiente ronda o vuelve al menú.",
  "pause.title": "Menú del juego",
  "pause.resume": "Continuar",
  "pause.menu": "Volver al menú principal",
  "upgrade.title": "Elige una mejora",
  "upgrade.generic.title": "Mejora",
  "upgrade.generic.description": "Mejora tu build.",
  "upgrade.newWeaponPrefix": "Nueva arma:",
  "upgrade.stat.maxHp.title": "Vida máxima",
  "upgrade.stat.maxHp.description": "Aumenta la vida máxima.",
  "upgrade.stat.speed.title": "Velocidad de movimiento",
  "upgrade.stat.speed.description": "Aumenta la velocidad de movimiento.",
  "upgrade.stat.generic.title": "Mejora de estadística",
  "upgrade.stat.generic.description": "Mejora tus estadísticas.",
  "upgrade.weapon.projectileShot.title": "Disparo de proyectiles",
  "upgrade.weapon.projectileShot.description": "Añade disparos de proyectiles a tu build.",
  "upgrade.weapon.orbitingBalls.title": "Bolas orbitales",
  "upgrade.weapon.orbitingBalls.description": "Añade bolas orbitales a tu build.",
  "upgrade.weapon.damageZone.title": "Zona de daño",
  "upgrade.weapon.damageZone.description": "Añade una zona de daño alrededor de tu personaje.",
  "upgrade.weapon.generic.title": "Arma",
  "upgrade.weapon.generic.description": "Añade esta arma a tu build.",
  "upgrade.weaponUpgrade.frequency.title": "Frecuencia",
  "upgrade.weaponUpgrade.frequency.description": "Ataca más a menudo.",
  "upgrade.weaponUpgrade.range.title": "Alcance",
  "upgrade.weaponUpgrade.range.description": "Aumenta el alcance del arma.",
  "upgrade.weaponUpgrade.projectileCount.title": "Cantidad de proyectiles",
  "upgrade.weaponUpgrade.projectileCount.description": "Crea más proyectiles.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Velocidad de proyectiles",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Hace que los proyectiles sean más rápidos.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Velocidad orbital",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Hace que las bolas orbitales giren más rápido.",
  "upgrade.weaponUpgrade.damage.title": "Daño",
  "upgrade.weaponUpgrade.damage.description": "Inflige más daño.",
  "upgrade.weaponUpgrade.generic.title": "Mejora de arma",
  "upgrade.weaponUpgrade.generic.description": "Mejora esta arma.",
  "defeat.title": "Derrota",
  "defeat.subtitle": "Reaparece o vuelve al menú",
  "defeat.respawn": "Reaparecer",
  "defeat.menu": "Menú principal",
  "error.generic": "Algo salió mal.",
} as const;
